/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Decoding_Options_LabelInputs */

const en_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decoding Options`)
};

const fr_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options de decodage`)
};

const de_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dekodierungsoptionen`)
};

const it_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni di decodifica`)
};

const ru_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Варианты декодирования`)
};

const es_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de decodificación`)
};

const zh_cn2_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解码选项`)
};

const ja_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デコードオプション`)
};

const hi_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिकोडिंग विकल्प`)
};

const pt_pt2_subtitle_import_decoding_options_label = /** @type {(inputs: Subtitle_Import_Decoding_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções de decodificação`)
};

/**
* | output |
* | --- |
* | "Decoding Options" |
*
* @param {Subtitle_Import_Decoding_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_decoding_options_label = /** @type {((inputs?: Subtitle_Import_Decoding_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Decoding_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_decoding_options_label(inputs)
	if (locale === "de") return de_subtitle_import_decoding_options_label(inputs)
	if (locale === "it") return it_subtitle_import_decoding_options_label(inputs)
	if (locale === "ru") return ru_subtitle_import_decoding_options_label(inputs)
	if (locale === "es") return es_subtitle_import_decoding_options_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_decoding_options_label(inputs)
	if (locale === "ja") return ja_subtitle_import_decoding_options_label(inputs)
	if (locale === "hi") return hi_subtitle_import_decoding_options_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_decoding_options_label(inputs)
	return en_subtitle_import_decoding_options_label(inputs)
});